/**
 * Format question text for display: convert markdown-style bold (**text**) to HTML
 * so generated questions with ** don't show raw asterisks.
 * Use for read-only display only; escape HTML first to avoid XSS.
 */
export function formatQuestionTextForDisplay(text: string | null | undefined): string {
  if (text == null || typeof text !== 'string') return '';
  let html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  // Bold: **text** or __text__
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__([^_]+)__/g, '<strong>$1</strong>');
  // Italic: *text* (single asterisk, no double)
  html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  return html;
}
